// extracted by mini-css-extract-plugin
module.exports = {"title":"ListingInfo_title__vPjOc"};